import { ContainedButton } from "@/common";
import { styled } from "@mui/material";
import { tokens } from "@/tokens";

export const ContainerHeading = styled("div")({
  backgroundColor: "rgba(5, 34, 35, 0.12)",
  borderRadius: "12px",
  padding: "25px",
  position: "relative",
  "& svg": {
    color: tokens.bg.surface,
  },

  "& h6": {
    marginTop: "10px",
    fontWeight: tokens.fontWeight.normal,
  },
});

export const StyledContainedButton = styled(ContainedButton)(() => ({
  width: "100% !important",
  borderRadius: `${tokens.radius.sm} !important`,
  borderColor: tokens.border.default,
}));
